export const sundayAbbreviatedLowercase = "_UiMpe";
export default {sundayAbbreviatedLowercase};